// Sepeti temizle fonksiyonu
class CartClear extends HTMLElement {
    constructor() {
        super();
        this.clearButton = this.querySelector('.cart-clear-button');
        
        if (this.clearButton) {
            this.clearButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.clearCart();
            });
        }
    }

    clearCart() {
        // Loading overlay göster
        const cartForm = document.querySelector('#cart');
        if (cartForm) {
            cartForm.classList.add('processing');
        }

        // Mevcut hata mesajını temizle
        const existingAlert = document.querySelector('.cart-clear-alert');
        if (existingAlert) {
            existingAlert.remove();
        }

        // Sepeti temizle isteği
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.item_count === 0) {
                // Başarılı - sayfayı yenile
                window.location.reload();
            } else {
                // Hata durumu
                this.showError();
            }
        })
        .catch(error => {
            console.error('Sepet temizleme hatası:', error);
            this.showError();
        })
        .finally(() => {
            if (cartForm) {
                cartForm.classList.remove('processing');
            }
        });
    }

    showError() {
        const errorMessage = document.querySelector('html').lang === 'tr' 
            ? 'Sepet temizlenirken bir hata oluştu. Lütfen tekrar deneyin.'
            : 'An error occurred while clearing the cart. Please try again.';

        const alert = document.createElement('div');
        alert.classList.add('cart-clear-alert', 'alert', 'alert--error');
        alert.style.cssText = `
            padding: 1rem;
            margin: 1rem 0;
            background-color: #fee;
            border: 1px solid #fcc;
            border-radius: 4px;
            color: #c00;
        `;
        alert.textContent = errorMessage;

        const cartContainer = document.querySelector('.cart-clear-container');
        if (cartContainer) {
            cartContainer.after(alert);
            
            // 5 saniye sonra hatayı kaldır
            setTimeout(() => {
                alert.remove();
            }, 5000);
        }
    }
}

customElements.define('cart-clear', CartClear);

document.addEventListener('DOMContentLoaded', function() {
    const clearButton = document.querySelector('.cart-clear-button');
    
    if (clearButton) {
        clearButton.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Loading durumu
            clearButton.style.opacity = '0.5';
            clearButton.style.pointerEvents = 'none';

            fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(data => {
                // Başarılı - sayfayı yenile
                window.location.reload();
            })
            .catch(error => {
                console.error('Hata:', error);
                alert('Bir hata oluştu. Lütfen tekrar deneyin.');
                clearButton.style.opacity = '1';
                clearButton.style.pointerEvents = 'auto';
            });
        });
    }
});